const Footer = () => {

    return (
        <>
            <footer className="">
                <div className="footer_bottom text-center"><p className="copyright_text m-0 text-uppercase text-white">Copyright© 2025 Tether Mine. All Rights Reserved.</p></div>
            </footer>
        </>
    )
}

export default Footer;